import { FiList, FiPlus } from "react-icons/fi";
import { TbEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

export default function Header({ UpdateView, invester }) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center px-1 py-3 border-b-2 border-[var(--background)]">
      {/* LEFT */}
      <button onClick={UpdateView} className="p-2 transition">
        <FiList className="w-6 h-6 text-[var(--text)]" />
      </button>

      {/* CENTER */}
      <h1 className="text-lg font-bold text-left pl-2 flex-1">Quotes</h1>

      {/* RIGHT */}
      <div className="flex justify-end gap-3">
        {/* Search Symbol */}
        {invester === 1 ? null : (
          <button
            onClick={() => navigate("/EditSymbol")}
            className="p-2 transition"
          >
            <TbEdit className="w-6 h-6 text-[var(--text)]" />
          </button>
        )}
        {/* Add Symbol */}
        {invester === 1 ? null : (
          <button
            onClick={() => navigate("/AddSymbol")}
            className="p-2 rounded-full transition"
          >
            <FiPlus className="w-6 h-6 text-[var(--text)]" />
          </button>
        )}
      </div>
    </div>
  );
}
